let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("koFxW")).then(() => parcelRequire('jNDUp'));